export default "__VITE_ASSET__CXQpJ_zw__"